// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"

Rails.start()
Turbolinks.start()
ActiveStorage.start()
import "channels"

import "bootstrap"
import "../stylesheets/application"
window.$ = window.Jquery = require('jquery')

import 'select2'
import 'select2/dist/css/select2.css'

//require("googlec")
require("sla_setter")
require("chartkick")
require("chart.js")

//window.braintree = require("braintree")
import {taskSorter} from 'task_sorter'
import {sits} from 'sits'
import {googlec} from 'googlec'
import {liveSearch} from "../utils/live-search"
import {init_select2} from "../utils/select2handler"
window.init_select2 = init_select2
window.liveSearch = liveSearch
window.sits = sits
window.googlec = googlec
window.loadModal = function (selector) {
  $(selector).modal('show').on('shown.bs.modal', function() {
    document.activeElement.blur()
    $(selector + " .modal-body").scrollTop(0)
  })
}
window.closeModal = (selector) => { $(selector).modal('hide') }

import "controllers"

function refresher(fn) {
  fn()
}

window.vegaEmbed = require('vega-embed').default;

document.addEventListener("turbolinks:load", () => {
  $('[data-toggle="tooltip"]').tooltip()
  $('[data-toggle="popover"]').popover()
  liveSearch();
  init_select2();

  document.addEventListener("select2Refresh", () => refresher(init_select2))
  document.addEventListener("liveSearchRefresh", () => refresher(liveSearch))
  taskSorter();

})

require("trix")
require("@rails/actiontext")
